<rt-message
  *ngFor="let error of errors; trackBy: trackByErrorMessage"
  variant="context-error small"
  margin-top
>
  {{ error }}
</rt-message>
